import axiosClient from '../axiosClient';

export const getCoupons = (params) => axiosClient.get('/admin/coupons', { params });

export const getCouponDetail = (id) => axiosClient.get(`/admin/coupons/${id}`);

export const createCoupon = (data) => axiosClient.post('/admin/coupons', data);

export const updateCoupon = (id, data) => axiosClient.put(`/admin/coupons/${id}`, data);

export const deleteCoupon = (id) => axiosClient.delete(`/admin/coupons/${id}`);
